import { APP_ROUTES } from "../navigation/appRoutes";

export default function AuthFooter({ wide = false }) {
  return (
    <footer
      className={`auth-footer ${wide ? "auth-footer--wide" : ""}`}
      aria-label="Links legais do orion33"
    >
      <span aria-label="Copyright orion33">&copy; orion33</span>
      <span aria-hidden="true">&bull;</span>
      <a href={APP_ROUTES.PRIVACY}>Privacidade</a>
      <span aria-hidden="true">&bull;</span>
      <a href={APP_ROUTES.TERMS}>Termos</a>
      <span aria-hidden="true">&bull;</span>
      <span className="auth-footer__email">contato@orion33.com.br</span>
    </footer>
  );
}
